import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  isInfoToast = false;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { message: string; type: ToastType },
    private translate: TranslateService
  ) {
    if (data.type === 'info') {
      this.isInfoToast = true;
    }
  }

  getIconPath(type: ToastType) {
    return `toast-${type}`;
  }
}
